import axios from "axios"

export function getAuthHeader(authToken) {
  if (authToken) {
    return { Authorization: `Bearer ${authToken}` }
  } else {
    return null
  }
}

export function post({ authToken, queryName, query, variables }) {
  const requestData = { queryName, query, variables }
  const config = { headers: { ...getAuthHeader(authToken) } }
  return axios
    .post(process.env.REACT_APP_GRAPHQL_ENDPOINT, requestData, config)
    .then(response => {
      const graphqlResponse = response.data

      const data = graphqlResponse.data
      const graphqlErrors = internalizeGraphqlErrors(graphqlResponse.errors)

      return { data, graphqlErrors }
    })
    .catch(axiosError => {
      const graphqlResponse = (axiosError.response && axiosError.response.data) || {}

      const data = graphqlResponse.data
      const graphqlErrors = internalizeGraphqlErrors(graphqlResponse.errors)
      const networkError = internalizeNetworkError(axiosError)

      return { data, graphqlErrors, networkError }
    })
}

function internalizeGraphqlErrors(errors) {
  return errors && errors.map(internalize)
}

function internalize(graphqlError) {
  const { message, extensions, path } = graphqlError || {}
  const { code, data } = extensions || {}
  return { message, code, data, path }
}

function internalizeNetworkError(error) {
  return error
}



// WEBPACK FOOTER //
// ./src/common/graphql/index.js